import { Email } from '../types/email';

/**
 * Default welcome email that appears for all new inboxes
 */
export const welcomeEmail: Email = {
  id: -1, // Using a negative ID to distinguish from real emails
  subject: 'Welcome to MailDerp',
  from: 'team@mailderp.com',
  to: '', // Will be filled in with the current inbox email
  body: `Welcome to MailDerp!

We're excited to have you use our disposable email service. Any emails sent to your temporary address will appear here automatically.

Some tips:
- Your emails will be deleted after 1 hour
- Create a new email address anytime using the refresh button
- This service is completely free and private

Happy emailing!
The MailDerp Team`,
  htmlBody: `
<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
  <h2 style="color: #646cff;">Welcome to MailDerp!</h2>
  
  <p>We're excited to have you use our disposable email service. Any emails sent to your temporary address will appear here automatically.</p>
  
  <h3>Some tips:</h3>
  <ul>
    <li>Your emails will be deleted after 1 hour</li>
    <li>Create a new email address anytime using the refresh button</li>
    <li>This service is completely free and private</li>
  </ul>
  
  <p>Happy emailing!<br>The MailDerp Team</p>
</div>
`,
  read: false,
  date: new Date()
};

/**
 * Merges welcome/default emails with actual emails from the database
 */
export function mergeWithDefaultEmails(emails: Email[], inboxEmail: string): Email[] {
  // Clone the welcome email and set the correct recipient
  const customWelcomeEmail = {
    ...welcomeEmail,
    to: inboxEmail,
    date: new Date() // Always use the current date
  };
  
  // If there are no actual emails, just return the welcome email
  if (!emails || emails.length === 0) {
    return [customWelcomeEmail];
  }
  
  // Otherwise, add the welcome email to the beginning (most recent)
  return [customWelcomeEmail, ...emails];
}